import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FuseVerticalNavigationAsideItemComponent } from './aside/aside.component';
import { FuseVerticalNavigationBasicItemComponent } from './basic/basic.component';
import { FuseVerticalNavigationCollapsableItemComponent } from './collapsable/collapsable.component';
import { FuseVerticalNavigationDividerItemComponent } from './divider/divider.component';
import { FuseVerticalNavigationGroupItemComponent } from './group/group.component';
import { FuseVerticalNavigationSpacerItemComponent } from './spacer/spacer.component';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatTooltipModule
    ],
    declarations: [
        FuseVerticalNavigationAsideItemComponent,
        FuseVerticalNavigationBasicItemComponent,
        FuseVerticalNavigationCollapsableItemComponent,
        FuseVerticalNavigationDividerItemComponent,
        FuseVerticalNavigationGroupItemComponent,
        FuseVerticalNavigationSpacerItemComponent
    ],
    exports: [
        FuseVerticalNavigationAsideItemComponent,
        FuseVerticalNavigationBasicItemComponent,
        FuseVerticalNavigationCollapsableItemComponent,
        FuseVerticalNavigationDividerItemComponent,
        FuseVerticalNavigationGroupItemComponent,
        FuseVerticalNavigationSpacerItemComponent
    ]
})
export class FuseVerticalNavigationItemsModule { }
